// extracted by mini-css-extract-plugin
export default {"container":"StudentsTests_container__hjjKn","page":"StudentsTests_page__5D-uh","content":"StudentsTests_content__Nk+gD","list":"StudentsTests_list__rq2hk"};